module.exports = __webpack_public_path__ + "static/media/studentBlueIcon.e6c24a2f.svg";